import { useState } from 'react';
import { useForm } from 'react-hook-form';
import Button from 'src/components/atoms/button/button';
import Checkbox from 'src/components/atoms/checkbox/checkbox';
import { Form, FormError, FormItem, FormRow } from 'src/components/atoms/form';
import Modal from 'src/components/atoms/modal/modal';
import { Commission } from 'src/models/commission.model';
import { useAppDispatch, useAppSelector } from 'src/reducers';
import { validationSchema } from 'src/utils/validation-utils';
import styles from '../commissions.module.scss';
import { createCommission } from '../../../../reducers/commissions.reducer';
import Spinner from 'src/components/atoms/spinner/spinner';

export const CreateCommission = () => {
  const dispatch = useAppDispatch();

  const [handleGlobal, setHandleGlobal] = useState<boolean>(false);
  const { loading } = useAppSelector(state => state.commissions);

  const commission = {
    commissionName: '',
    global: handleGlobal,
  } as Commission;

  const {
    register,
    getValues,
    setValue,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues: { commission },
  });

  const handleCheckGlobal = () => {
    setHandleGlobal(!handleGlobal);
  };

  const sendCreateCommission = data => {
    setValue('commission.global', handleGlobal);
    dispatch(createCommission(data));
  };

  return (
    <>
      <Modal.Header />
      <Modal.Body>
        <Form>
          <FormRow>
            <FormItem>
              <input
                autoComplete="off"
                className={`form-control ${errors.commission?.commissionName ? 'is-invalid' : ''}`}
                {...register('commission.commissionName', validationSchema.required)}
                type="text"
                placeholder="Nome commessa"
              />
              <FormError error={errors.commission?.commissionName} validation={validationSchema.required} />
            </FormItem>
          </FormRow>
          <FormRow>
            <FormItem>
              <div className={styles.globalCheckbox}>
                <Checkbox checked={handleGlobal} onCheck={() => handleCheckGlobal()} {...register('commission.global')} />
                <label>Commessa globale</label>
              </div>
            </FormItem>
          </FormRow>
          <FormRow>
            <Button
              size="md"
              rounded="rounded-md"
              color="light-grey"
              mode="outline"
              fullWidth
              disabled={!isValid || loading}
              onClick={() => sendCreateCommission(getValues())}
            >
              {loading ? <Spinner /> : 'Crea commessa'}
            </Button>
          </FormRow>
        </Form>
      </Modal.Body>
    </>
  );
};
